import './App.css';
import { Link } from 'react-router-dom';

function Home(): React.JSX.Element {
  return (
    <div className="App home-page">
      <div className="home-container">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content-left">
            <h1 className="hero-title-minimal">Richard Przybek</h1>
            <p className="hero-subtitle-minimal">Software Engineer</p>
          </div>
          <div className="hero-links-minimal">
            {/* <Link to="/macro" className="hero-link">Macro</Link> */}
            <Link to="/blog" className="hero-link">Blog</Link>
          </div>
        </div>

        {/* About & Experience Section */}
        <div className="about-experience-section">
          <div className="about-part">
            <h2 className="section-title-small">About</h2>
            <div className="about-text">
              <p>
                I'm interested in how things work — how people become themselves, how systems shape behavior, and how automation can make the world better.
              </p>
            </div>
          </div>
          <div className="experience-part">
            <h2 className="section-title-small">Experience</h2>
            <div className="experience-list">
              <div className="experience-item">
                <div className="experience-header">
                  <div className="experience-meta">
                    <h3 className="job-title-small">Software Engineer & Founder</h3>
                    <p className="experience-org">
                      <span className="company-small">Photo Competition App</span>
                      <span className="date-small">2025 – 2026</span>
                    </p>
                  </div>
                  <ul className="experience-details">
                    <li>Built a full-stack weekly photo competition app in React Native (Expo, TypeScript) and Python (Django REST Framework), covering photo submission, ranking systems, a leaderboard, prize redemption, and user profiles</li>
                    <li>Implemented JWT/social authentication, AWS S3 media storage, push notifications, and reporting for photo moderation</li>
                    <li>Led alpha testing across Apple/Android with early users, collected feedback, and prioritized enhancements</li>
                  </ul>
                </div>
              </div>
              <div className="experience-item">
                <div className="experience-header">
                  <div className="experience-meta">
                    <h3 className="job-title-small">Software Developer</h3>
                    <p className="experience-org">
                      <span className="company-small">Epic Systems</span>
                      <span className="date-small">2022 – 2025</span>
                    </p>
                  </div>
                  <ul className="experience-details">
                    <li>Built data models for Cosmos EHR research platform, ensuring efficient and scalable data organization</li>
                    <li>Designed SQL table structures and optimized ETL pipelines enhancing data extraction and minimizing load times for large data-sets encompassing billions of records</li>
                    <li>Developed a Python-based data auditing tool with SQLAlchemy, automated via GitLab runners and deployed in Docker containers to monitor data model changes for improved data integrity and transparency</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Skills Section */}
        <div className="skills-section">
          <h2 className="section-title-small">Skills</h2>
          <div className="skills-list">
            <span className="skill-tag">Python</span>
            <span className="skill-tag">SQL</span>
            <span className="skill-tag">React</span>
            <span className="skill-tag">React Native</span>
            <span className="skill-tag">Flutter</span>
            <span className="skill-tag">Django</span>
            <span className="skill-tag">C</span>
            <span className="skill-tag">C++</span>
            <span className="skill-tag">C#</span>
            <span className="skill-tag">Java</span>
            <span className="skill-tag">M</span>
            <span className="skill-tag">Git</span>
            <span className="skill-tag">Data Modeling</span>
            <span className="skill-tag">Docker</span>
            <span className="skill-tag">AWS</span>
          </div>
        </div>

        {/* Contact Section */}
        <div className="contact-section">
          <h2 className="section-title-small">Contact</h2>
          <div className="contact-links-compact">
            <a href="mailto:rich.przybek@gmail.com" className="contact-link-compact">
              <span>Email</span>
            </a>
            <a href="https://www.linkedin.com/in/richard-przybek/" target="_blank" rel="noopener noreferrer" className="contact-link-compact">
              <span>LinkedIn</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;

